// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__SqzeY","white":"Tooltip_white__EzDVR","black":"Tooltip_black__Erbns"};